export default __webpack_public_path__ + "static/media/spectrophotometer-info-5.6955293c.svg";